module.exports = __webpack_public_path__ + "static/media/Gotham-BoldItalic.ef9a499a.ttf";